<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span>
        {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_TITLE' | translate }}
      </span>

      <button mat-icon-button (click)="closeDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="content__body">
      <div class="content__room-creation">
        <div class="room-creation__wrapper">
          <form [formGroup]="addNewRoomFormGroup" data-at-provide-email>
            <mat-form-field class="room-creation__room-name" mat-input-height-small>
              <input
                matInput
                formControlName="name"
                [placeholder]="
                  '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_ROOM_NAME_INPUT' | translate
                "
              />

              <mat-error
                data-at-add-room-modal-error-not-unique-room
                *ngIf="addNewRoomFormGroup.controls.name.hasError('notUnique')"
              >
                {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_ROOM_NOT_UNIQUE' | translate }}
              </mat-error>
              <mat-error
                data-at-add-room-modal-error-too-long
                *ngIf="addNewRoomFormGroup.controls.name.hasError('maxlength')"
              >
                {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_TOO_LONG_ROOM_NAME' | translate }}
              </mat-error>
              <mat-error
                data-at-add-room-modal-error-not-valid
                *ngIf="
                  addNewRoomFormGroup.controls.name.hasError('pattern') ||
                  addNewRoomFormGroup.controls.name.hasError('consecutiveSpaces')
                "
              >
                {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_NOT_VALID_ROOM_NAME' | translate }}
              </mat-error>
              <mat-error
                data-at-add-room-modal-error-required
                *ngIf="addNewRoomFormGroup.controls.name.hasError('required')"
              >
                {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_REQUIRED_ROOM_NAME' | translate }}
              </mat-error>
            </mat-form-field>

            <div class="room-creation__room-type">
              <mat-form-field mat-select-height-small>
                <mat-label>{{
                  '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_ROOM_TYPE_INPUT' | translate
                }}</mat-label>
                <mat-select formControlName="type">
                  <mat-select-trigger>
                    <span>
                      {{
                        '+INSTALLATIONS.INSTALLATION.SRC.ROOM.' +
                          addNewRoomFormGroup.controls.type?.value | translate
                      }}
                    </span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let option of roomTypeOptions" [value]="option">
                    {{ '+INSTALLATIONS.INSTALLATION.SRC.ROOM.' + option | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <button
                gtm="onPreviousStep"
                gtmAction="Add room"
                gtmCategory="addRoomModal"
                mat-raised-button
                color="primary"
                [disabled]="
                  !addNewRoomFormGroup.controls.name.valid ||
                  addNewRoomFormGroup.controls.name.value === '' ||
                  (installationFeaturesStore.isAddRoomDisabled$ | async)
                "
                (click)="addRoom()"
              >
                {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_ADD_ROOM_BUTTOM' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="content__added-rooms">
        <span class="added-rooms__title">
          {{ '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_ADDED_ROOMS_TITLE' | translate }}
        </span>
        <div class="added-rooms__content">
          <div class="added-rooms__entry" *ngFor="let room of addedRooms">
            {{ room?.properties?.name?.value | translate }}
            <mat-icon
              gtm="onClose"
              gtmAction="Delete Room Attempt"
              gtmCategory="addRoomModal"
              class="grey-icon"
              (click)="deleteRoom(room)"
              [matTooltip]="
                '+SRC_COMMISSIONINGV2.ADD_ROOM_STANDALONE_DELETE_ROOM_TOOLTIP' | translate
              "
              >close</mat-icon
            >
          </div>
        </div>
      </div>
    </div>
  </mat-card-content>

  <mat-card-actions>
    <button
      data-at-add-room-modal-close-btn
      gtm="onClose"
      gtmAction="Close modal"
      gtmCategory="addRoomModal"
      mat-stroked-button
      color="primary"
      (click)="closeDialog()"
    >
      {{ 'GENERAL.BUTTON.CLOSE' | translate }}
    </button>

    <button
      data-at-add-room-modal-close-btn
      gtm="onClose"
      gtmAction="Close modal"
      gtmCategory="addRoomModal"
      mat-raised-button
      color="primary"
      (click)="closeDialog()"
    >
      {{ 'GENERAL.BUTTON.CONFIRM' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
